import React from 'react';
import { Star } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-14 pb-6 md:pt-20 md:pb-10 px-4 overflow-hidden bg-[#0d0d0d]" data-id="element-121">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_50%_50%,_rgba(255,107,0,0.08),transparent_70%)]" style={{
      contain: 'strict'
    }} data-id="element-122" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-123">
        <div className="flex flex-col items-center text-center hero-animate" data-id="element-124">
          <h1 className="md:text-5xl font-bold text-shadow-lg uppercase pb-[0px] text-[31px] pt-[0px] mb-[0px]" style={{
          marginTop: '0px'
        }} data-id="element-125">
            <span className="underline decoration-[#FF6B00] decoration-[3px] underline-offset-4" data-id="element-126">
              CONSTRUÍ
            </span>{' '}
            PROYECTOS DE HERRERÍA{' '}
            <span className="relative inline-block" data-id="element-127">
              <span className="relative z-10 underline decoration-[#FF6B00] decoration-[3px] underline-offset-4" data-id="element-128">
                PROFESIONALES
              </span>
            </span>{' '}
            EN MENOS DE{' '}
            <span className="relative inline-block text-[#FF6B00]" style={{
            textShadow: '0 0 20px rgba(255,107,0,0.6), 0 0 40px rgba(255,107,0,0.3)'
          }} data-id="element-129">
              <span className="relative z-10" data-id="element-130">24 HORAS</span>
            </span>
          </h1>

          <p className="text-white/90 max-w-xl font-[400] text-[16px] pt-[15px] mb-[10px]" data-id="element-131">
            Accedé al{' '}
            <span className="font-bold text-white" data-id="element-132">
              Sistema Maestro de Herrería
            </span>{' '}
            con{' '}
            <span className="font-bold text-white underline decoration-[#FF6B00]" data-id="element-133">
              +600 Planos Metálicos
            </span>{' '}
            con medidas exactas.
            <br data-id="element-134" />
            <br data-id="element-135" />
            Para que dejes de improvisar y perder material y logres empezar a
            fabricar muebles de estilo industrial{' '}
            <span className="font-bold text-white italic" data-id="element-136">
              que sí se venden.
            </span>
          </p>
        </div>

        {/* Product Image — LCP element */}
        <div className="relative mb-5 max-w-3xl mx-auto hero-animate-delay-1" data-id="element-137">
          {/* Floating trust badges */}
          <div className="absolute -bottom-3 left-2 md:left-4 z-20 flex items-center gap-1.5 bg-[#FF6B00] text-white font-black text-xs md:text-sm px-3 py-1.5 md:px-4 md:py-2 rounded-full shadow-[0_4px_20px_rgba(255,107,0,0.5)] border border-[#FF8C00]/50 uppercase tracking-wide" data-id="element-138">
            <span className="text-sm md:text-base" data-id="element-139">📐</span>
            <span data-id="element-140">+600 Planos</span>
          </div>
          <div className="absolute -bottom-3 right-2 md:right-4 z-20 flex items-center gap-1.5 bg-[#111] text-[#22C55E] font-black text-xs md:text-sm px-3 py-1.5 md:px-4 md:py-2 rounded-full shadow-[0_4px_20px_rgba(0,0,0,0.6)] border border-[#22C55E]/30 uppercase tracking-wide" data-id="element-141">
            <span className="text-sm md:text-base" data-id="element-142">🛡️</span>
            <span data-id="element-143">120 Días de Garantía</span>
          </div>

          {/* Aspect-ratio container prevents CLS */}
          <div style={{
          aspectRatio: '800 / 450'
        }} className="relative" data-id="element-144">
            <img src="https://cdn.magicpatterns.com/uploads/dHjdkFVq1CSwAqzQEJKpPD/ChatGPT_Image_11_feb_2026,_04_40_03_p.m..webp" alt="Sistema Maestro de Herrería — Planos listos para fabricar" className="w-full h-full rounded-lg shadow-2xl object-cover" width={800} height={450} fetchPriority="high" decoding="sync" data-id="element-145" />
          </div>
        </div>

        {/* CTA Area */}
        <div className="flex flex-col items-center text-center hero-animate-delay-2" data-id="element-146">
          <div className="flex items-center gap-2 mb-3 text-[#FFD700]" data-id="element-147">
            <div className="flex" data-id="element-148">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-current" data-id="element-149" />)}
            </div>
            <span className="text-white font-medium ml-2" data-id="element-150">4.9/5</span>
            <span className="text-gray-500 text-sm" data-id="element-151">
              — Clientes Satisfechos
            </span>
          </div>

          <CTAButton size="xl" className="w-full md:w-auto mb-2 text-sm md:text-xl" data-id="element-152">
            QUIERO MIS PLANOS
          </CTAButton>

          <p className="text-sm text-gray-400 mb-1" data-id="element-153">
            Acceso Inmediato a +600 Planos + 8 Bonos &gt;&gt;
          </p>

          <p className="text-xs text-gray-500 mb-2" data-id="element-154">
            Pago único. Sin cargos mensuales.
          </p>
        </div>
      </div>
    </section>;
}